import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aarogya_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401 anywhere, clear the stale token and bounce to /login (unless we're
// already on a public auth page — that would create a loop).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const p = window.location.pathname;
      if (!["/login", "/login/otp", "/register", "/"].includes(p)) {
        localStorage.removeItem("aarogya_token");
        window.location.assign("/login");
      }
    }
    return Promise.reject(err);
  },
);

export default api;
